import { createSelector } from '@opengov/compose-app/reselect';
import { IReportDatasetLens, ITemplateReadable } from '@opengov/reporting-types';

import { reportTemplateSelector } from './reportTemplateState';

export const selectReportTemplatesForCurrentEntity = createSelector(
  reportTemplateSelector,
  (state) => state.reportTemplates
);

export const selectReportTemplatesLoading = createSelector(
  reportTemplateSelector,
  (state) => state.loadingReportTemplates.active
);

export const selectCurrentTemplate = createSelector(
  reportTemplateSelector,
  (state): ITemplateReadable => state.currentTemplate
);

export const selectCurrentTemplateId = createSelector(
  reportTemplateSelector,
  (state) => state.currentTemplate && state.currentTemplate.id
);

export const selectCurrentLens = createSelector(
  reportTemplateSelector,
  (state): IReportDatasetLens => state.currentLens
);

export const selectCurrentTemplateStandardLensType = createSelector(
  selectCurrentTemplate,
  // if there is more than one ... what are we going to do?
  (template) => {
    return template && template.standardLensTypes[Object.keys(template.standardLensTypes)[0]].lensType;
  }
);

export const selectCurrentTemplateTemplateGroup = createSelector(
  selectCurrentTemplate,
  (template) => template.templateGroup
);

export const selectHasFetchedEntityLenses = createSelector(
  reportTemplateSelector,
  (state) => state.hasFetchedEntityLenses
);

export const selectCurrentTemplateQueryString = createSelector(reportTemplateSelector, (state) => state.queryString);
